export const documentation = [

  {
    title: "Getting Started",
    description:
      "Learn how to register your business, configure your account and start using Magyne.",
    links: [
      "Creating your Magyne account",
      "Setting up your organization",
      "Managing users",
      "Understanding roles and permissions"
    ]
  },

  {
    title: "Magyne Platform",
    description:
      "Learn about the core features available across all Magyne solutions.",
    links: [
      "Dashboard overview",
      "Authentication and security",
      "Tenant management",
      "Reports and analytics"
    ]
  },

  {
    title: "Carwash Pro",
    description:
      "Guides for managing modern car wash operations.",
    links:[
      "Creating services",
      "Managing vehicles",
      "Job cards",
      "Invoices and payments"
    ]
  },

  {
    title: "School Admin (K-12)",
    description:
      "Documentation for schools managing academic operations.",
    links:[
      "Student registration",
      "Classes and subjects",
      "Examinations",
      "Report cards"
    ]
  },

  {
    title:"Campus Pro",
    description:
      "Resources for universities and colleges.",
    links:[
      "Admissions",
      "Courses and programmes",
      "Student registration",
      "Results management"
    ]
  }

];